export default __webpack_public_path__ + "static/media/generated_MarcaCorona_Panella-Milano_Terra_18.jpg.1400x1400_q85.3446fb2f.jpg";